const { CrudModel } = require('./crud');

export interface BaseReportBodyPayload {
	unitId: number;
	startDateTime: { $gte: string; $lte: string }
}

export interface SumOfShiftsPerSpecialtyBodyPayload extends BaseReportBodyPayload {
	specialtyIds: number[];
}

export class ReportModel extends CrudModel {
	constructor() {
		super('admin/report');
	}

	async getWeekdayWeekendReport(shiftFilter: any) {
		return this.executeAction(null, "getWeekdayWeekendReport", { shiftFilter }, true);
	}

	async getSumOfShiftsPerSpecialty(payload: SumOfShiftsPerSpecialtyBodyPayload) {
		return this.executeAction(null,'getSumOfShiftsPerSpecialty', payload, true)
	}

	async getSumOfHoursAndPayments(payload: BaseReportBodyPayload) {
		return this.executeAction(null,'getSumOfHoursAndPayments', payload, true)
	}

	async getLumpSumPaymentsReport(shiftFilter: any) {
		return this.executeAction(null, "getLumpSumPaymentsReport", shiftFilter, true);
	}

	async getCNES(shiftFilter: any) {
		return this.executeAction(null, "getCNES", shiftFilter, true);
	}

	async getValidatedShiftsReport(shiftFilter: any) {
		return this.executeAction(null, "getValidatedShiftsReport", shiftFilter, true);
	}

	async getAccountabilityReport(shiftFilter: any) {
		return this.executeAction(null, "accountabilityReport", shiftFilter, true);
	}

	async getAnalyticalTransferReport(shiftFilter: any) {
		return this.executeAction(null, "analyticalTransferReport", shiftFilter, true);
	}
}

export default new ReportModel();
